import { create } from "zustand";
import { persist } from "zustand/middleware";
import { addData } from "../services/centralized";

export type LengthUnit =
  | "inch"
  | "foot"
  | "millimeter"
  | "centimeter"
  | "decimeter"
  | "meter"
  | "kilometer";
export type ForceUnit =
  | "pound"
  | "kiloPound"
  | "kilogram"
  | "metricTon"
  | "newton"
  | "decaNewton"
  | "kiloNewton"
  | "megaNewton";

interface UnitState {
  lengthUnit: LengthUnit;
  forceUnit: ForceUnit;
  setLengthUnit: (unit: LengthUnit) => void;
  setForceUnit: (unit: ForceUnit) => void;
  resetToDefaults: () => void;
}

const defaultUnits = {
  lengthUnit: "meter" as LengthUnit,
  forceUnit: "kiloNewton" as ForceUnit,
};

export const useUnitStore = create<UnitState>()(
  persist(
    (set) => ({
      ...defaultUnits,
      setLengthUnit: (unit) => set({ lengthUnit: unit }),
      setForceUnit: (unit) => set({ forceUnit: unit }),
      resetToDefaults: () => set(defaultUnits),
    }),
    {
      name: "atcivil-unit-configuration",
    }
  )
);

// Subscribe to UnitStore and publish to centralized store
useUnitStore.subscribe((state) => {
  addData("units", {
    lengthUnit: state.lengthUnit,
    forceUnit: state.forceUnit,
  });
  console.log(
    "✅ [UnitStore→Centralized] Published units:",
    state.lengthUnit,
    ",",
    state.forceUnit
  );
});
